$(document).ready(function () {
  function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();

    $("body").append($temp);
    $temp.val($(element).children("span").html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function () {
      $(element).html(oldValue);
    }, 300);
    $temp.remove();
  }

  $("cupom").click(function () {
    copyToClipboard(this);
  });

  // Clique na lista de produtos do kit
  // $(".productView-selectProductKit .product-info").on("click", (e) => {
  //   $clone = $(e.currentTarget).clone();
  //   const inserTarget = $(e.currentTarget)
  //     .parents(".selection-wrapper")
  //     .find(".empty-selection");
  //   if (inserTarget.children(".product-info").length > 0)
  //     inserTarget.children(".product-info").replaceWith($clone);
  //   else inserTarget.removeClass("is-empty").append($clone);
  //   inserTarget.find("input").prop("checked", false);
  // });
  // // Lógica para adição ao carrinho do kit
  // if ($(".template-product .kit").length) {
  //   window.kitProducts = [null, null, null, null];
  //   $(".productView-selectProductKit .product-info").on("click", (e) => {
  //     window.kitProducts[$(e.currentTarget).data("index")] = $(
  //       e.currentTarget
  //     ).data("product-id");
  //     updateAddKitToCartButton(window.kitProducts);
  //   });
  // }
  // const updateAddKitToCartButton = (array) => {
  //   const hasNullValue = array.some((element) => !element);
  //   if (!hasNullValue) $("#add-kit-to-cart").prop("disabled", false);
  // };
  // const addKitToCart = () => {
  //   return new Promise((resolve, reject) => {
  //     let dataForm = "quantity=" + 1 + "&id=" + window.kitProducts.shift();
  //     var params = {
  //       type: "POST",
  //       url: "/cart/add.js",
  //       data: dataForm,
  //       dataType: "json",
  //       success: (line_item) => {
  //         if (window.kitProducts.length > 0) {
  //           addKitToCart().then(resolve).catch(reject);
  //         } else {
  //           resolve(line_item);
  //         }
  //       },
  //       error: (XMLHttpRequest, textStatus) => {
  //         var message = window.cartStrings.addProductOutQuantity2;
  //         if (input.length > 0) {
  //           var maxValue = parseInt(input.attr("data-inventory-quantity"));
  //           message = getInputMessage(maxValue);
  //           input.val(maxValue);
  //         }
  //         Shopify.onError(XMLHttpRequest, textStatus, message);
  //         reject(new Error(message));
  //       },
  //     };
  //     $.ajax(params);
  //   });
  // };
  // $("#add-kit-to-cart").on("click", (e) => {
  //   $(e.currentTarget).addClass("is-loading");
  //   addKitToCart().then(() => {
  //     Shopify.getCart(window.updateCart);
  //     $(e.currentTarget).removeClass("is-loading");
  //   });
  // });

  if ($(document.body).hasClass("template-product")) {
    window.kitProducts = [0, 0, 0, 0];

    $('.selection-wrapper .dropdown-product-kit input[type="checkbox"]').on(
      "change",
      function (e) {
        if ($(this).is(":checked")) {
          $(`.selection-wrapper input[type="checkbox"]`)
            .not(this)
            .prop("checked", false);
        }
      }
    );

    $('.selection-wrapper input[type="radio"]').on("change", function (event) {
      // Fecha os seletores abertos
      $(`.selection-wrapper input[type="checkbox"]`).prop("checked", false);

      // Clona o item para dentro do label para visualização do produto escolhido
      const index = $(this).data("index");
      const incipient = $(event.currentTarget)
        .closest(".product-kit-selection")
        .find("#target" + index);
      const item = $(event.currentTarget)
        .closest(".dropdown-product-item")
        .clone(false);

      incipient.children().remove();
      item.appendTo(incipient);

      if (
        $(event.currentTarget)
          .closest(".product-kit-selection")
          .children("label.is-empty").length
      ) {
        $(event.currentTarget)
          .closest(".product-kit-selection")
          .children("label.is-empty")
          .removeClass("is-empty");
      }

      window.kitProducts[index] = $(this).val();

      let hasNullValue = false;
      window.kitProducts.forEach((item, index) => {
        if (!item) hasNullValue = true;
      });

      if (!hasNullValue) {
        $("#add-kit-to-cart").prop("disabled", false);
      }
    });

    $("#add-kit-to-cart").on("click", function (event) {
      $(event.currentTarget).addClass("is-loading");

      const queue = [...window.kitProducts];
      Shopify.moveAlong = function () {
        if (queue.length) {
          var request = queue.shift();
          let dataForm = "quantity=" + 1 + "&id=" + request;
          var params = {
            type: "POST",
            url: "/cart/add.js",
            data: dataForm,
            dataType: "json",
            beforeSend: function () {
              console.log(dataForm);
            },
            success: function (line_item) {
              Shopify.moveAlong();
            },
            error: function (XMLHttpRequest, textStatus) {
              console.log("Erro ao adicionar");
            },
          };
          $.ajax(params);
        } else {
          $(event.currentTarget).removeClass("is-loading");
          Shopify.getCart((cartTotal) => {
            $("body").addClass("cart-sidebar-show");
            $("body").find("[data-cart-count]").text(cartTotal.item_count);
            window.updateCart(cartTotal);
          });
        }
      };
      Shopify.moveAlong();
    });
  }
  // COMPRA RÁPIDA
  $(document).on("click", "[data-add-kit-to-cart]", function () {
    const btn = $(this);
    $(btn).addClass("is-loading");
    const json = $(this).data("json");
    console.log(json);
    const quantitySelectorValue = parseInt(
      $(".form-input.quantity__input").val()
    );
    Shopify.queue = [];
    json.forEach((item) => {
      Shopify.queue.push({
        variantId: item.variant_id,
        quantity: item.quantity * quantitySelectorValue,
      });
    });
    Shopify.moveAlong = function () {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        let dataForm =
          "quantity=" + request.quantity + "&id=" + request.variantId;
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: dataForm,
          dataType: "json",
          beforeSend: function () {
            console.log(dataForm);
          },
          success: function (line_item) {
            Shopify.moveAlong();
          },
          error: function (XMLHttpRequest, textStatus) {
            console.log("Erro ao adicionar");
          },
        };
        $.ajax(params);
      } else {
        $(btn).removeClass("is-loading");
        $(".content-compra-rapida").removeClass("is-loading");
        $(".content-compra-rapida").find("loading-overlay--custom").remove();
        $("body").removeClass("compra-rapida-aberto");
        Shopify.getCart((cartTotal) => {
          $("body").addClass("cart-sidebar-show");
          $("body").find("[data-cart-count]").text(cartTotal.item_count);
          window.updateCart(cartTotal);
        });
      }
    };
    Shopify.moveAlong();
  });
  $(".btn-quantity").on("click", function () {
    var inputElement = $(this).siblings(".qtd-input");
    var currentValue = parseInt(inputElement.val());
    var maxInventory = parseInt(inputElement.attr("data-inventory"));
    if ($(this).hasClass("plus")) {
      if (currentValue < maxInventory) {
        inputElement.val(currentValue + 1).trigger("change");
      }
    } else if ($(this).hasClass("minus")) {
      if (currentValue > 0) {
        inputElement.val(currentValue - 1).trigger("change");
      }
    }
  });
  $(".qtd-input").on("change", function () {
    var inputValue = parseInt($(this).val());
    var maxInventory = parseInt($(this).attr("data-inventory"));
    if (inputValue < 0) {
      $(this).val(0);
    } else if (inputValue > maxInventory) {
      $(this).val(maxInventory).trigger("change");
    }
  });

  // UPSELL Carrinho
  window.upsellSliderInit = function () {
    $(".recommend-slider .swiper-wrapper").slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: true,
      dots: true,
      infinite: false,
      arrows: true,
      prevArrow: ".swiper-button-prev",
      nextArrow: ".swiper-button-next",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: false,
          },
        },
      ],
    });

    $(".recommend-container").addClass("loaded");
  };

  function beforeSend(element) {
    $("#dropdown-cart").addClass("updating-cart");
    $(element).find(".recommend-btn-add").addClass("is-loading");
  }

  function afterSend(element) {
    $("#dropdown-cart").removeClass("updating-cart");
    $(element).find(".recommend-btn-add").removeClass("is-loading");
  }

  $(document).on("submit", ".upsell-form", function (e) {
    e.preventDefault();

    const formData = new FormData(this);
    const serializedData = {};
    formData.forEach((value, key) => {
      serializedData[key] = value;
    });
    const jsonData = JSON.stringify(serializedData);

    // URL da API da Shopify para adicionar um item ao carrinho
    const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

    // Opções da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonData,
    };

    beforeSend(e.target); // Ação "before send" antes da requisição

    // Faz a requisição usando fetch com ação "before send" e "after send"
    fetch(addToCartUrl, requestOptions)
      .then((response) => {
        afterSend(); // Ação "after send" após a conclusão da requisição

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
        Shopify.getCart(window.updateCart);
        $("body").addClass("cart-sidebar-show");
      })
      .catch((error) => {
        // Houve um erro na requisição, você pode tratar o erro aqui
        console.error("Error:", error);
      });
  });

  $(document).on("change", ".variants-product-selects select", function () {
    var $currentSelect = $(this);
    var $nextSelect = $currentSelect
      .closest(".variants-product-selects")
      .find("select")
      .eq($currentSelect.index() + 1);

    if ($nextSelect.length && $nextSelect.is(":hidden")) {
      $nextSelect.show();
    } else if (!$nextSelect.length) {
      var selectedOptions = $currentSelect
        .closest(".variants-product-selects")
        .find("select")
        .map(function () {
          return $(this).val();
        })
        .get();
      var productData = JSON.parse(
        $currentSelect
          .closest(".infoProduct")
          .find("[data-json-product]")
          .text()
      );

      var matchingVariant = productData.find(function (variant) {
        return selectedOptions.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      if (matchingVariant && matchingVariant.available) {
        $currentSelect
          .closest(".infoProduct")
          .find(".variantIdAddCart")
          .val(matchingVariant.id);
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .prop("disabled", false);
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .val("ADICIONAR");
      } else {
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .prop("disabled", true);
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .val("ESGOTADO");
        console.log("Produto esgotado");
      }
    }

    var container = $(".halo-cart-sidebar").find(".previewCart");
    var scrollTo = $(".halo-cart-sidebar").find(".recommend-container");

    // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
    var scrollPosition =
      scrollTo.offset().top +
      scrollTo.outerHeight() +
      container.scrollTop() -
      container.position().top;

    // Realiza a rolagem
    container.animate(
      {
        scrollTop: scrollPosition,
      },
      1000
    );
  });
});
